import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { InsuranceFlowDetailsResponse } from 'src/app/_types/insurance-flow.types';
import {
  CreateLeadResponse,
  ProposalDetails,
} from 'src/app/_types/proposals.type';
import { buildAbsoluteUrl } from 'src/app/helpers/url.helper';
import { AddLeadModalComponent } from 'src/app/shared/components/add-lead-modal/add-lead-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { TaskDetailsService } from '../../task-details.service';

/**
 * Action block of the task header: shareable link and new-request creation.
 * Shared by the task-details modal and the task-details page — the host decides
 * what happens once a lead is created.
 */
@Component({
  selector: 'app-task-details-header-actions',
  standalone: true,
  imports: [CommonModule, IconsModule, AddLeadModalComponent],
  templateUrl: './task-details-header-actions.component.html',
  styleUrl: './task-details-header-actions.component.css',
})
export class TaskDetailsHeaderActionsComponent {
  @Output() leadCreated = new EventEmitter<CreateLeadResponse>();

  constructor(
    private readonly taskDetailsService: TaskDetailsService,
    private readonly router: Router,
    private readonly toastrService: ToastrService,
    @Inject(APP_BASE_HREF) private readonly baseHref: string
  ) {}

  protected get insuranceFlowData(): InsuranceFlowDetailsResponse | null {
    return this.taskDetailsService.state.insuranceFlowData;
  }

  protected get policy(): ProposalDetails | null {
    return this.taskDetailsService.state.policy;
  }

  protected get isLoading(): boolean {
    return this.taskDetailsService.state.isLoading;
  }

  protected get canEdit(): boolean {
    return this.taskDetailsService.state.canEdit;
  }

  protected copyLink(): void {
    const flowId = this.insuranceFlowData?.id;
    if (!flowId) {
      return;
    }

    navigator.clipboard.writeText(
      buildAbsoluteUrl(this.router, this.baseHref, ['/proposal/flow', flowId])
    );
    this.toastrService.success($localize`Lien copié avec succès`);
  }
}
